import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ServidorImpressaoExecutorService} from "../../services/servidor-impressao-executor.service";

@Component({
  selector: 'app-modal-gerenciador-jobs-impressao',
  templateUrl: './modal-gerenciador-jobs-impressao.component.html',
  styleUrls: ['./modal-gerenciador-jobs-impressao.component.scss']
})
export class ModalGerenciadorJobsImpressaoComponent implements OnInit{
  @Input() empresa: any = {};
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onFecharModal: any = new EventEmitter();
  constructor(    public servidorExecutor: ServidorImpressaoExecutorService) {
  }

  ngOnInit(): void {
  }

  fechar(fechou: boolean = false) {
    this.onFecharModal.emit({ fechou: fechou });
  }

}
